var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"agreement",domProps:{"innerHTML":_vm._s(_vm.agreement)}}),(_vm.loading)?_c('van-loading',{staticClass:"loading",attrs:{"type":"spinner"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }